module.exports = require("/Users/y-sakanaka/ist/1_projects/bridgestone/tire-ai-02/dev_fe/src/store/create")